import React from 'react'
import { Modal } from "react-bootstrap";

const Loader = (props) => {
  return (
    <>
        <Modal
            show={props.show}
            animation={false}
            className='bg-transparent loaderModal'>
            <div className='modal-loader-wrapper'>
                <div class="customloader"></div>
            </div>
        </Modal>
    </>
  )
}

export default Loader